
<template>
  <div class="scrollable">

    <div v-if="loading" class="" style="height:500px;">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div v-else-if="!trData.length" class="" style="height:500px;">
      <el-card class="table-box-card" style="height:300px;">
        <img :src="src" alt="noRecord" width="40" height="40"><br>
        <span class="no-data">{{tip}}</span>
      </el-card>
    </div>
    <div v-else class="table-box">
      <el-table :class="className" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
        ref="multipleTable" stripe :data="trData" :highlight-current-row="true" style="width: 100%;" height="550" tooltip-effect="dark"
        cell-mouse-enter="mouseEnterCall">
        <el-table-column type="selection" width="55" height="20" v-if='params.selection'>
        </el-table-column>
        <el-table-column v-for="(item,index) in thData" :key='index' :prop='item.name' :label='item.label' :width='item.width'>
          <template slot-scope="scope">
            <span v-if="item.name==='amount'">{{financial(scope.row['amount'], scope.row.currency)}}</span>
            <span v-else-if="item.name==='realAmount' && scope.row['realAmount']">{{scope.row['statusKey']==='completed'?financial(scope.row['realAmount'], scope.row.realCurrency):'--'}}</span>
            <span v-else-if="item.name==='exchangeAmount' && scope.row['exchangeAmount']">{{financial(scope.row['exchangeAmount'], scope.row.exchangeCurrency)}}</span>
            <span v-else-if="item.name==='fundBankType' && scope.row['fundBankType']">{{scope.row['fundBankType']==='BANK_SECURITIES'?$t('common.yztransfer'):'--'}}</span>
            <span v-else-if="item.name==='lockWay' && scope.row['lockWay']">{{scope.row['lockWay']==='IN'?$t('exchange.lockIn'):$t('exchange.lockOut')}}</span>
            <span v-else>{{scope.row[item.name] || '--'}}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="hidden-md-and-down" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.totalPage"
        :page-sizes="params.pageSizes" :page-size="params.pageSize" layout="sizes, prev, pager, next, jumper" :total="params.total">
      </el-pagination>

      <el-pagination class="hidden-lg-and-up my-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.totalPage"
        :page-sizes="params.pageSizes" :page-size="params.pageSize" layout="prev, pager, next" :total="params.total" :pager-count="5">
      </el-pagination>

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
    },
  props: ['thData', 'trData', 'tip', 'params', 'src', 'loading', 'className'],
  computed: {

  },

  methods: {
    mouseEnterCall (row, column, cell, event) {
      console.log(row, column, cell, event)
    },
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    handleCurrentChange (val) {
      this.$emit('current-change', val)
    },
    financial (x, currency) {
      if (x) {
        let amount = this.Util.formatCurrency(x)
      return `${currency} ${amount}`
      } else {
        return '--'
      }
    }
  },

  mounted () {},

  components: {},

  watch: {

  }

}

</script>
<style lang="scss">
.table-box-card{
  text-align: center;
  padding-top: 200px;
}
  .base_ele_table {
    .ai-jc {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
  }
  .el-pagination__sizes{
.el-input__inner{
color:  #fec000 !important;
font-weight: 300;

  }
  }
  .el-card{
    border:0;
  }
  .no-data {
    font-family: PingFangTC-Regular;
    font-size: 12px;
    color: #7d7d7d;
    letter-spacing: -0.19px;
    margin-top: 16px;
  }
.spinner {
  margin: 100px auto 0;
  width: 150px;
  text-align: center;
}

.spinner > div {
  width: 30px;
  height: 30px;
  background-color: #fec000;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.table-box {
	overflow: auto;
}

@-webkit-keyframes bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0.0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 40% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
    .el-pagination{
      margin-top:20px;
    }
    .el-table__row {
      height: 20px;
      &:hover {
        background: #fff !important;
      }
    }
    th {
      font-size: 12px;
      font-family: "Muli-Bold";
      color: #0f2c52;
    }
    .el-table__row--striped {
      background-color: #f3f4f6;
      td {
        background-color: transparent !important;
      }
    }
  }
  .my-pagination{
    text-align: center;
    .el-pager li{
      min-width: auto;
    }
    button{
      padding: 0;
    }
    .btn-prev{
      padding-right: 0;
    }
    .btn-next{
      padding-left: 0;
    }
  }
</style>
